export default {
  HIGHLIGHTED_HEADINGS: [],
  SEARCHBAR_SUGGESTIONS_HEADING: "Popular Searches",
  SEARCHBAR_RECENTS_HEADING: "Recently Searched",
  SEARCHBAR_INVAIDSEARCHMESSAGE: "Please input something to search...",
  SEARCHBAR_PLACEHOLDER: "Search ",
  DEFAULT_SEARCHBRAND: "NNNOW",
};
